import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './index.module.css';

const Disclaimer: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.TermsOfService}>
        {t('By continuing, you agree to our')}{' '}
        <Link to="/patient-terms-of-use">{t('Terms of Use')}</Link>.
      </div>
      <div className={styles.Disclaimer}>
        {t(
          `Use of this tool is for non-urgent communications only, and responses may not be reviewed by your provider. If you require an immediate response, call your provider's office directly. In the event of a medical emergency, dial 911 or visit your closest emergency room immediately.`,
        )}
      </div>
    </>
  );
};

export default Disclaimer;
